<template>
  <Card class="page-abstractInfo" v-if="dataSource.length">
    <div slot="title">
      <caring-title
        style="margin-bottom: 0; padding-left: 20px"
        :customIconStyle="{ height: '100%' }"
      >
        <div style="color: #333; font-size: 16px">摘要信息</div>
      </caring-title>
    </div>
    <div class="wrap">
      <template v-for="d in dataSource" >
        <el-popover
          v-if="d.list.length > 1"
          :key="d.id"
          v-model="d.chart_show"
          class="item-wrap"
          placement="top"
          width="600"
          trigger="hover">
          <div class="item" slot="reference">
            <span class="label">{{d.list && d.list.length ? (d.trend_type === 1 ? d.list[d.list.length -1].value : d.list[d.list.length -1].score)  : '暂无数据'}}</span>
            <span class="value">{{d.name}}</span>
            <span class="extra">{{d.list && d.list.length ? d.list[d.list.length -1].time : '--'}}</span>
          </div>
          <more-info-trend v-if="d.chart_show" :type="d.trend_type" :dataSource="d.list"></more-info-trend>
        </el-popover>
        <div v-else class="item-wrap" :key="d.id">
          <div class="item">
            <span class="label">{{d.list && d.list.length ? (d.trend_type === 1 ? d.list[d.list.length -1].value : d.list[d.list.length -1].score)  : '暂无数据'}}</span>
            <span class="value">{{d.name}}</span>
            <span class="extra">{{d.list && d.list.length ? d.list[0].time : '--'}}</span>
          </div>
        </div>
      </template>
    </div>
  </Card>
</template>
<script>
import CaringTitle from "../../../components/caring-title.vue";
import moreInfoTrend from "./moreInfoTrend.vue";
import { getModuleSummaryListApi, getModuleTrendApi } from "../../../api/config";
export default {
  components: {
    CaringTitle,
    moreInfoTrend
  },
  props: {
    configType: {
      type: Number | String,
      default: ""
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataSource: [],
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getModuleSummaryListApi({type: this.configType, category: 0}).then((res) => {
        if (res.code === 0) {
          this.dataSource = res.data.map(d => {
            d.chart_show = false;
            d.list = [];
            return d;
          });
          this.dataSource.map(d => {
            this.getTrend(d);
          })
        } else {
          this.$Message.error(res.message);
        }
      })
    },
    getTrend(t) {
      let p = {
        type: this.configType,
        trend_type: t.trend_type,
        bind_code: t.bind_code,
        trend_code: t.trend_code
      }
      if (this.configType == 1) {
        p.patient_id = this.info.patient_id
      } else {
        p.person_id = this.info.id
      }
      getModuleTrendApi(p).then(res => {
        if (res.code === 0) {
          this.$set(t, 'list', res.data);
        } else {
          this.$Message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
.page-abstractInfo{
  margin-top: 10px;
  .ivu-card-body{
    padding: 0;
  }
  .wrap{
    display: flex;
    flex-direction: row;
    overflow-x: auto;
  }
  .item-wrap{
    position: relative;
    padding: 20px;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 250px;
    box-sizing: border-box;
    &:not(:last-child) {
      &::after{
        content: ' ';
        position: absolute;
        right: 0;
        top: 50%;
        width: 1px;
        height: 50%;
        background-color: #EAEEF7;
        transform: translateY(-50%);
      }
    }
  }
  .item{
    position: relative;
    text-align: center;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 210px;
    box-sizing: border-box;
    font-family: Microsoft YaHei;
    cursor: pointer;
    .label{
      font-size: 17px;
      color: #4286F1;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .value{
      color: #738299;
      font-size: 14px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .extra{
      color: #B4C1D4;
      font-size: 12px;
    }
    // .icon{
      // position: absolute;
      // cursor: pointer;
      // top: 0px;
      // right: 20px;
      // width: 20px;
      // height: 20px;
    // }
  }
}
</style>
